<template>
  <div class="container">
    <div class="form-wrapper">
      <el-form :model="form" :inline="true" :rules="rules" ref="ruleForm" label-width="120px" size="small" style="max-width: 1232px">
        <div class="header">
          <div class="title">新增SPU</div>
          <div class="add-sku">
            <el-button type="text" size="normal" @click="goSku">已评审产品</el-button>
          </div>
          <el-form-item label="SPU编码：" prop="spuCode">
            <el-input v-model.trim="form.spuCode" readonly />
          </el-form-item>
          <el-form-item label="所属板块：" prop="plate">
            <el-select v-model="form.plate">
              <el-option :label="item" :value="item" v-for=" (item,index) in ['板式', '软体']" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品评审时间:" prop="productReviewDate">
            <el-date-picker v-model="form.productReviewDate" value-format="yyyy-MM-dd" size="small" type="date" style="width: 150px" placeholder="选择日期"> </el-date-picker>
          </el-form-item>
          <br/>
          <el-form-item label="SPU名称：" prop="spuName">
            <el-input
              v-model.trim="form.spuName"
              type="textarea"
              style="width: 228px;"
              :rows="4"
              show-word-limit
              maxlength="200" />
          </el-form-item>
          <el-form-item label="类别：" prop="productTypeCode">
            <el-select v-model="form.productTypeCode" @change="handleProductTypeCodeChange">
              <el-option :label="item.typeName" :value="item.typeCode" v-for="(item, index) in productTypeCodeList" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="预计上线时间：" prop="expOnelineTime">
            <el-date-picker
              v-model="form.expOnelineTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="SPU品类：" prop="spuCategory">
            <el-input v-model.trim="form.spuCategory" />
          </el-form-item>
          <template v-if="isShowStroe">
            <el-form-item label="店铺：" class="max-select" prop="storeCodes">
              <el-select v-model="form.storeCodes" multiple collapse-tags filterable placeholder="请选择">
                <el-option v-for="item in storeList" :key="item.storeCode" :label="item.storeName" :value="item.storeCode"> </el-option>
              </el-select>
            </el-form-item>
            <br/>
          </template>
          <el-form-item label="图片" prop="picList" style="width: 553px;">
            <el-upload
              action=""
              multiple
              :limit="5"
              :on-preview="handlePreview"
              :before-upload="beforeAvatarUpload"
              :on-exceed="handleExceed"
              :before-remove="handleBeforeRemove"
              :on-remove="handleRemove"
              :http-request="handleHttprequest"
              :file-list="form.picList">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip" style="line-height: 16px; color: #999;">
                说明：最多可上传5张图片，且每张图片<br/>不可大于2M
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="备注：" prop="productRemark">
            <el-input
              v-model="form.productRemark"
              type="textarea"
              :rows="4"
              placeholder="请输入内容"
              style="width: 435px;"
              show-word-limit
              maxlength="128"
            />
          </el-form-item>
        </div>
        <div class="main">
          <div class="title">参考产品</div>
          <div style="margin: 0 60px;">
            <el-table
              stripe
              border
              :header-cell-style="{backgroundColor: '#F4F8FB'}"
              :data="selectedSkuList"
            >
              <el-table-column label="产品型号" prop="productType" show-overflow-tooltip></el-table-column>
              <el-table-column label="产品描述" prop="productDesc" show-overflow-tooltip></el-table-column>
              <el-table-column label="品类" prop="veriety" show-overflow-tooltip></el-table-column>
              <el-table-column label="风格" prop="style" show-overflow-tooltip></el-table-column>
              <el-table-column label="空间" prop="spaceRoom" show-overflow-tooltip></el-table-column>
              <el-table-column label="主色" prop="mainColor" show-overflow-tooltip></el-table-column>
              <el-table-column label="材质" prop="texture" show-overflow-tooltip></el-table-column>
            </el-table>
          </div>
          <div class="title">关联SKU</div>
          <div class="add-sku">
            <el-button type="primary" size="small" @click="addsku">新增SKU</el-button>
          </div>
          <div style="height: calc(100% - 60px); overflow: auto;">
            <transition-group name="list-complete" tag="p">
              <div v-for="(item, index) in form.skuList" :key="item.tempId" class="list-complete-item">
                <el-form-item label="sku编码" label-width="90px">
                  <el-input v-model.trim="item.skuCode" v-if="form.productTypeCode != '2' && !isShowSkuInput" />
                  <remote-select
                    v-model="item.skuCode"
                    :requestMethod="data=>$q.newProduct.querySku({params: {skuCode: data}})"
                    label="skuCode"
                    value="skuCode"
                    @isSelect="handleRmoteSelectComplete({status: arguments[0], index: index})"
                    @activedNode="handleActivedNode({data: arguments[0], index: index})"
                    v-else
                  ></remote-select>
                </el-form-item>
                <el-form-item label="商品定位" label-width="90px">
                  <el-select v-model="item.goodsLocation">
                    <el-option :label="e.optionValue" :value="e.id" v-for="(e, i) in locationOpt" :key="i"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="风格" label-width="90px">
                  <el-select v-model="item.style">
                    <el-option :label="e.optionValue" :value="e.id" v-for="(e, i) in styleList" :key="i"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否有样" label-width="90px">
                  <el-select v-model="item.sampleFlag">
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </el-form-item>
                <el-button type="text" style="margin-left: 15px; margin-top: 2px;" @click="delsku(index)">删除</el-button>
                <el-button type="text" style="margin-left: 15px; margin-top: 2px;" @click="asyncData(index)">同属性SKU</el-button>
              </div>
            </transition-group>
          </div>
        </div>
        <div class="footer">
          <el-button type="primary" @click="submit" :loading="loading">保存</el-button>
        </div>
      </el-form>
      <img-preview v-model="imgPreviewVisible" :data="form.picList" :detailType="0" v-if="imgPreviewVisible"></img-preview>
    </div>
    <async-data v-model="asyncDataVisible" v-if="asyncDataVisible" @callback="handleCallback"></async-data>
  </div>
</template>

<script>
import moment from 'moment'
import imgPreview from '@/views/components/imgPreview.vue'
import imgUploadMixin from './img-upload.mixin'
import asyncData from './async'
import pagePathMixin from '@/utils/page-path-mixin'
import axios from "@/utils/axiosInstance";
export default {
  name: 'newproductAdd',
  mixins: [imgUploadMixin, pagePathMixin],
  components: { imgPreview, asyncData },
  data() {
    const formatExpOnelineTim = (rule, value, callback) => {
      let now = moment(value).format('x')
      let startDate = moment(moment().format('YYYY-MM-DD')+' 00:00:00').format('x');
      if(startDate > now) {
        callback(new Error('日期不能早于今日'))
      }else{
        callback();
      }
    }
    return {
      form: {
        spuCode: '',
        spuName: '',
        productTypeCode: '',
        expOnelineTime: '',
        spuCategory: '',
        productRemark: '',
        skuList: [],
        picList: [],
        storeCodes: [],
      },
      productTypeCodeList: [],
      styleList: [],
      locationOpt: [],
      rules: {
        spuName: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        productTypeCode: [
          { required: true, message: '不能为空', trigger: 'change' }
        ],
        expOnelineTime: [
          { required: true, message: '不能为空', trigger: 'blur' },
          { validator: formatExpOnelineTim, trigger: 'change' }
        ],
        spuCategory: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        picList: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        plate: [
          { required: true, message: '不能为空', trigger: 'change' }
        ],
        storeCodes: [
          { required: true, message: '不能为空', trigger: 'change' }
        ],
      },
      imgPreviewVisible: false,
      loading: false,
      selectedSkuList: [],
      asyncIndex: 0,
      asyncDataVisible: false,
      storeList: [],
      isShowStroe: false,
      isShowSkuInput: false
    }
  },
  created() {
    this.getOptionType();
    this.get_goodsAttrLocationSelect();
    this.get_spu();
    this.getNewProductType();
    this.getStoreList();
  },
  mounted() {
    this.$bus.$off('selectSku').$on('selectSku', data=>{
      data = data.filter(v=>!this.selectedSkuList.find(k=>k.dataId === v.dataId));
      this.selectedSkuList = [...data, ...this.selectedSkuList];
    })
  },
  methods: {
    get_spu() {
      this.$q.newProduct.createCode()
      .then(res=>{
        this.form.spuCode = res.message;
      })
    },
    getNewProductType() {
      this.$q.newProduct.getNewProductType()
      .then(res=>{
        this.productTypeCodeList = res.data;

        this.form.productTypeCode = res.data[0].typeCode;
        this.handleProductTypeCodeChange();
      })
    },
    // 类别change事件，关联sku清空
    handleProductTypeCodeChange(val) {
      let obj = val ? this.productTypeCodeList.find(v=>v.typeCode == val) : {}
      this.isShowStroe = obj.typeName == '店铺专供'
      this.isShowSkuInput = ['新品-多页面', '新品-无限制', '店铺专供'].includes(obj.typeName)
      // this.form.productTypeCode = res.data[0].typeCode;
      this.rules.storeCodes[0].required = this.isShowStroe
      !this.isShowStroe && this.$refs.ruleForm.clearValidate('storeCodes')
      this.form.skuList = [];
      this.addsku();
    },
    addsku() {
      this.form.skuList.push({
        tempId: Date.now(),
        skuCode: '',
        goodsLocation: '',
        style: '',
        sampleFlag: '',
        isSelect: '否'
      })
    },
    delsku(index) {
      this.form.skuList.splice(index, 1)
    },
    asyncData(index) {
      let tagRow = this.form.skuList[this.asyncIndex];
      let isComplete = tagRow.goodsLocation || tagRow.style || tagRow.sampleFlag
      if(isComplete) {
        this.asyncIndex = index;
        this.asyncDataVisible = true;
      }else{
        this.$message.error('请将该SKU信息至少维护一个属性后进行批量操作！')
      }
    },
    handleCallback({rowNum}) {
      let tagRow = this.form.skuList[this.asyncIndex];
      for(let i = 0; i < rowNum; i++) {
        this.form.skuList.push(JSON.parse(JSON.stringify({
          ...tagRow,
          skuCode: ''
        })))
      }
    },
    submit() {
      this.loading = true;
      this.$refs['ruleForm'].validate(valid=>{
        if(valid) {
          this.$q.newProduct.addSpu({data: this.form})
          .then(res=>{
            this.$message(res.message)
            this.$router.push({name: 'newproductProcess',params: { type: 'add' }})
            this.$store.dispatch('tagsView/delVisitedView', this.$route);
            this.$store.dispatch('tagsView/delCachedView', this.$route);
          })
          .finally(_=>{
            this.loading = false;
          })
        }else{
          this.loading = false;
        }
      })
    },
    // 类别为翻拍，sku编码是通过选择的话，isSelet参数要设置为true，输入的则为false
    handleRmoteSelectComplete() {
      let {status , index} = arguments[0];
      if(status) {
        this.form.skuList[index].isSelect = '是';
      }
    },
    // 把选中的选项对象带过来
    handleActivedNode() {
      let {data , index} = arguments[0];
      this.form.skuList[index].goodsLocation = data.goodsLocation;
      this.form.skuList[index].style = data.style;
      this.form.skuList[index].sampleFlag = data.sampleFlag;
    },
    // (商品属性维护页面搜索)商品定位下拉数据
    get_goodsAttrLocationSelect() {
      this.$q.goods.goodsAttrLocationSelect().then(res => {
        this.locationOpt = res.data;
      });
    },
    // 获取风格下拉选项
    getOptionType() {
      this.$q.goods.goodsQueryOptionType().then(res => {
        this.styleList = res.data.styleList;
      });
    },
    //获取店铺
    getStoreList() {
      let currencyForm = {
        pageSize: 999999,
        pageNum: 1,
        hasCount: "N",
        reportCode: 'storeInfoList'
      }
      axios.post(`/ec-pc-api/custom/reports/data/storeInfoList`, currencyForm).then((res) => {
        if (res.code == 200) {
          this.storeList = res.data.list;
        }
      });
    },
    // 跳转到已评审产品页面
    goSku() {
      this.openSubPage({
        name: 'skuList',
        params: {
          type: 1
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .container
    margin 5px
    width auto 
    min-height calc(100% - 10px)
    box-sizing border-box
    border-radius 5px
  .form-wrapper
    height 100%
    background #ffffff
    border-radius 5px
    padding 10px
    box-sizing border-box
    .title
      font-weight bold
      font-size 16px
      color #444
      margin 15px 0
    .add-sku
      float right
      margin-top -36px
    >>> .el-form
      // display flex
      // flex-direction column
      // height 100%
      .header
        margin-bottom 10px
      .main
        flex 1
        overflow auto
      .footer
        text-align center
        margin-top 30px
        margin-bottom 30px

  >>> .el-upload-list
    position absolute
    left 220px
    top -5px
    width 240px


  .list-complete-item {
    transition: all 1s;
    display: block;
  }
  .list-complete-enter, .list-complete-leave-to
  /* .list-complete-leave-active for below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(30px);
  }
  .list-complete-leave-active {
    position: absolute;
  }

.max-select
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
    width 230px !important

>>> .el-select__tags-text {
  display: inline-block;
  max-width: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  }
>>> .el-tag__close.el-icon-close {
  top: 0px;
  right: -4px
}
</style>